module.exports = __webpack_public_path__ + "static/media/marker-in-progress.aa1f1197.png";